import React from 'react';
import { Dialog } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/en-gb';

import CalendarIcon from '../CalendarIcon';

import InfoListItem from '../InfoListItem';

import useCar from '../../../../../../context/useCar';
import { ToggleRPC, useTranslations } from 'components/utilities';

const PickUpDateInfoListItem = () => {
	const { t, i18n } = useTranslations();

	const { dropDate, pickupDate, handleChangePickupDate } = useCar();

	const dateFormatted = React.useMemo(() => {
		return moment(pickupDate, 'YYYY-MM-DD')
			.locale(i18n.language)
			.format('dddd D MMM');
		// eslint-disable-next-line
	}, [pickupDate]);

	const maxDate = React.useMemo(() => {
		return moment(dropDate).subtract(1, 'days').toDate();
	}, [dropDate]);

	return (
		<ToggleRPC>
			{({ on, toggle }) => (
				<>
					<Dialog open={on} onClose={toggle}>
						<DatePicker
							autoOk
							variant="static"
							value={pickupDate}
							disablePast
							maxDate={maxDate}
							onChange={(value) => {
								handleChangePickupDate(value);
								toggle();
							}}
						/>
					</Dialog>

					<InfoListItem
						button
						onClick={toggle}
						icon={CalendarIcon}
						title={t('car.pickupData')}
						info={dateFormatted}
					/>
				</>
			)}
		</ToggleRPC>
	);
};

export default PickUpDateInfoListItem;
